import { html, LitElement } from 'lit';

class ToujouBurger extends LitElement {
  static get is() {
    return 'toujou-burger';
  }

  static get properties() {
    return {
      toggleElement: {
        type: String,
        attribute: 'aria-controls',
      },
      externalTriggerElement: {
        type: String,
        attribute: 'data-external-trigger',
      },
    };
  }

  render() {
    return html`
      <slot id="content"></slot>
    `;
  }

  /**
   * Set status of the burger button and the element to toggle (ex: #mainNavigation)
   * according to the value
   * @param value
   * @private
   */
  set _status(value) {
    this.setAttribute('aria-pressed', value);
    this.setAttribute('aria-expanded', value);
    this._elementToToggle.setAttribute('aria-hidden', !value);
  }

  connectedCallback() {
    super.connectedCallback();

    this._elementToToggle = document.getElementById(this.toggleElement);
    this.addEventListener('keydown', this._onKeydown);

    this._onExternalClick = this._onExternalClick.bind(this);
    this._externalTrigger = document.getElementById(this.externalTriggerElement);
    this._externalTrigger.addEventListener('click', this._onExternalClick);
  }

  _onExternalClick() {
    this.click();
  }

  _onKeydown(event) {
    if (event.code === 'Enter' || event.code === 'Space') {
      this.click();
    }
  }

  /**
   * React to navigation state input change
   * and add corresponding aria attribute values
   *
   * @param event
   * @private
   */
  _handleStateChange(event) {
    this._status = event.currentTarget.checked;

    this.dispatchEvent(new CustomEvent('toujou-burger-button-click', {
      bubbles: true,
      composed: true,
      detail: {
        state: event.currentTarget.checked,
      },
    }));
  }
}

customElements.define(ToujouBurger.is, ToujouBurger);
